class DZModelBanner{

    /**
     * 主键
     */
     id = "";

    /**
     * 标题
     */
     title = "";

    /**
     * 图片ID
     */
     image = "";

     imageUrl = ""

    /**
     * banner类型：1-土地详情，2-民宿详情，3-需求详情，4-招商详情，5-外挑链接
     */
     type : string = "";

    /**
     * 内容：type为5时为网页地址，其他为对应ID
     */
     content = "";

    /**
     * banner动作 1-普通，2-静态，3-滚动
     */
    actionType = "";

    /**
     * 平台：pc , h5
     */
    sign = ""
}

export default DZModelBanner
